/**
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 * @param {any} x
 * @param {any} y
 * @returns {boolean}
 */
function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y; // +0 != -0
  }

  // eslint-disable-next-line no-self-compare
  return x !== x && y !== y; // NaN == NaN
}

export default is;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lyjs/es/utils/is.js
// module id = 778
// module chunks = 0